import { FC, ReactNode } from 'react';

const tooltipLabelToOffset: [number, number | undefined][] = [
  [5, 75], // Label with a length of 5 or less will be offset by 75px to the right.
  [10, 50], // Label with a length of 6 to 10 will be offset by 50px to the right.
  [15, 25], // Label with a length of 11 to 15 will be offset by 25px to the right.
  [20, undefined], // Label with a length of 16 to 20 will not be offset.
  [25, -25], // Label with a length of 21 to 25 will be offset by 25px to the left.
  [30, -50], // Label with a length of 26 to 30 will be offset by 50px to the left.
  [Infinity, -75] // Label with a length of 31 or more will be offset by 75px to the left.
];

function getTooltipOffsetFromLabelLength(length: number): number | undefined {
  for (const [maxLength, offset] of tooltipLabelToOffset) {
    if (!maxLength || length <= maxLength) {
      return offset;
    }
  }
  return undefined;
}

export type LabelProps = {
  children: ReactNode;
  classNames?: {
    label?: string;
    tooltip?: string;
  };
  /** @see FormControlProps.name of the control this form wraps. */
  htmlFor?: string | null;
  /** Tooltip displayed when icon next to the label is hovered. */
  tooltip?: string;
};

export const Label: FC<LabelProps> = ({
  children,
  classNames,
  htmlFor,
  tooltip
}) => {
  const tipOffset = typeof children === 'string' ? getTooltipOffsetFromLabelLength(children.length) : undefined;

  return (
    <label className={classNames?.label} htmlFor={htmlFor ?? undefined}>
      {children}
      {(!tooltip) ? null : (
        <span
          className={classNames?.tooltip}
          data-tip={tooltip}
          {...(tipOffset !== undefined ? { 'data-tip-offset': tipOffset } : {})}
        >
          <i className="fe icon-info"/>
        </span>
      )}
    </label>
  );
};
